import React, { useEffect, useState, useRef } from "react"
import { Container } from "react-bootstrap"
import { useSelector } from "react-redux"
import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/PartsViewer/v2/localization"
import useViewport from "@/hooks/useViewport"
import SwatchItems from "@/components/PartsViewer/v2/SwatchItems"
import NotifyItems from "@/components/PartsViewer/v2/NotifyMe"
import PriceLabel from "@/components/PartsViewer/v2/AddCart/PriceLabel"
import { partsAddToCartEvent } from "@/components/PartsViewer/v2/analytics.js"
import { shareaddToCart as addToCartHelper } from "@/components/sharedCart/shareCartHelper"
import { getProductInventory } from "@/services/productServices"
import Button from "@/components/core/Button/Button"
import {
  LoadingIcon,
  AddToCartLoadingIcon,
  IncIcon,
  DecIcon,
  WarnIcon,
  AddedIcon,
} from "@/components/PartsViewer/v2/icon.js"
import Style from "@/components/PartsViewer/v2/AddCart/index.module.scss"
import PropTypes from "prop-types"

const AddCart = props => {
  const {
    productId,
    setShowCart,
    showCart,
    partController,
    analytics,
    title,
    isListExtend,
    setCartToast,
    selectedFile,
  } = props
  const [loading, setLoading] = useState("loading")
  const [item, setItem] = useState({})
  const [variant, setVariant] = useState(null)
  const [variantList, setVariantList] = useState([])
  const [counter, setCounter] = useState(1)
  const [loaded, setLoaded] = useState(false)
  const [inventory, setInventory] = useState("")
  const [inventoryWarn, setInventoryWarn] = useState(false)
  const [isAdding, setIsAdding] = useState("")
  const device = useViewport()
  const { isDesktop, isSmallScreen } = useViewport()
  const pdpDetails = useSelector(state => state.pdp)
  const cartRef = useRef(null)
  const { t } = useTranslation("common")
  const cartFlagFullWidth = isListExtend && device.isLargeTabView
  const {
    addingCartText,
    addedCartText,
    addToCart,
    colorFinish,
    inventoryTextVal,
  } = getTranslations(t)

  useEffect(() => {
    getItemDetails(productId)
  }, [productId])

  useEffect(() => {
    let timeId
    if (inventory && counter > inventory) {
      setInventoryWarn(true)
      timeId = setTimeout(() => {
        setCounter(inventory)
      }, 300)
    }
    return () => clearTimeout(timeId)
  }, [counter])

  useEffect(() => {
    if (variant) {
      setCounter(1)
      setIsAdding("")
      getVarientInfo()
    }
  }, [variant])

  const getVarientInfo = async () => {
    const currentVarent = variantList?.filter(val => val.id === variant)[0]
    if (currentVarent) {
      setLoaded(true)
      const productQuantity = await getInventoryBySku(currentVarent?.id)
      setLoaded(false)
      setItem(prevState => {
        const details = prevState?.data?.varientDetails?.filter(
          val => val?.sku === currentVarent?.id
        )[0]
        return {
          ...prevState,
          currentVarent: { ...currentVarent, details },
        }
      })
      setInventory(productQuantity)
      setInventoryWarn(false)
      if (productQuantity && counter > productQuantity) {
        setCounter(productQuantity)
        setInventoryWarn(true)
      }
    }
  }

  const getItemDetails = async id => {
    const entry = partController.actions.get.entryByKey(id, selectedFile)
    setIsAdding("")
    setLoading("loading")
    if (entry?.ctApiPromise) {
      const ctResponse = await entry.ctApiPromise
      if (ctResponse) {
        setLoaded(true)
        const allSwatch = ctResponse?.data?.colorData
        const currentSwatch = allSwatch?.[0]?.id
        const productQuantity = await getInventoryBySku(currentSwatch)
        const details = ctResponse?.data?.varientDetails?.filter(
          val => val?.sku === currentSwatch
        )[0]

        setLoaded(false)
        setInventory(productQuantity)
        setVariantList(allSwatch)
        setVariant(currentSwatch)
        setItem({
          ...ctResponse,
          currentVarent: { ...allSwatch[0], details },
        })
        setLoading("success")
      }
    }
  }

  const incrementCounter = () => {
    setCounter(counter + 1)
  }

  const decrementCounter = () => {
    if (counter > 1) setCounter(counter - 1)
  }
  const handlerCounter = val => {
    const count = Number(val)
    if (count && count >= 1) {
      setCounter(count)
    }
  }

  const handlerCart = productInfo => {
    setLoaded(true)
    setIsAdding("adding")
    const data = [
      {
        sku: productInfo?.currentVarent?.id,
        quantity: counter,
        isBundleProduct: false,
        isBundle: false,
        brand: "kohler",
      },
    ]

    addToCartHelper(data, "", (isFailed, res) => {
      if (!isFailed && res) {
        updateCartFlag(counter)
        setLoaded(false)
        setIsAdding("done")
        setShowCart(false)
        const serviceVS = JSON.parse(localStorage.getItem("serviceVS"))
        if (serviceVS) {
          const datavs =
            JSON.parse(localStorage.getItem("servicePartsVs")) || []
          datavs.push(productInfo?.productId)
          sessionStorage.setItem("servicePartsVs", JSON.stringify(datavs))
        }
        partsAddToCartEvent(analytics, productInfo)
      }
    })
  }

  const getInventoryBySku = async sku => {
    const { inventories = [] } = await getProductInventory(sku)
    return inventories.length ? inventories[0]?.availableQuantity : 0
  }

  useEffect(() => {
    const closeAddCart = event => {
      if (cartRef.current && !cartRef.current.contains(event.target))
        setShowCart(false)
    }
    document.addEventListener("mousedown", closeAddCart)
    return () => document.removeEventListener("mousedown", closeAddCart)
  }, [setShowCart])

  const checkNoswatchfullWidth = cartFlagFullWidth && variantList.length < 1
  const checWithswatchfullWidth = cartFlagFullWidth && variantList.length > 1

  const itemStock =
    item?.currentVarent?.details?.discontinued === false &&
    (item?.currentVarent?.details?.isStock === "false" || inventory === 0)

  const itemDiscontinue = item?.currentVarent?.details?.discontinued

  const showStockMessage = itemStock && variantList.length <= 1
  const swatchClass = "align-items-center w-100"
  const swatchesCls =
    checWithswatchfullWidth && !itemStock
      ? "w-50 align-items-start"
      : swatchClass
  const fullscreenClass =
    checkNoswatchfullWidth || itemDiscontinue
      ? "w-100 align-items-start"
      : swatchesCls

  const getButtonLabel = isLoad => {
    if (isLoad && isAdding === "") {
      return <LoadingIcon />
    }
    if (isLoad && isAdding === "adding") {
      return (
        <>
          <LoadingIcon />
          <span className="adding-label">{addingCartText}</span>
        </>
      )
    }
    if (!isLoad && isAdding === "done") {
      return (
        <>
          <AddedIcon />
          <span className="adding-label">{addedCartText}</span>
        </>
      )
    } else {
      return addToCart
    }
  }

  const updateCartFlag = quantity => {
    const message = { quantity, status: true }
    setCartToast(message)
  }
  let overlaySection
  if (!isSmallScreen) {
    overlaySection = isListExtend
      ? "position-overlay-fixed"
      : "position-overlay-absolute"
  }

  const buttonHandler = () => {
    if (!loaded) {
      handlerCart({
        ...item,
        fileTitle: title,
        quantity: counter,
        pdpDetails,
      })
    }
  }

  return (
    <div className={`add-cart-modal ${Style.CartModalViewer}`}>
      <div className={`soverlay ${overlaySection}`}></div>
      <div
        ref={cartRef}
        className={`popup-cart-section ${overlaySection}  ${
          !isDesktop && showCart ? "mobile-snack-overlay" : ""
        }`}
      >
        <div
          className={`popup-wrappers mobile-dropdown ${
            loading === "loading" ? "loading-part" : "h-100"
          }`}
        >
          {loading === "loading" ? (
            <AddToCartLoadingIcon />
          ) : (
            <Container fluid>
              <div className="flex-column cart-content-dialogs">
                <div className="text-container">
                  <div className={`${isListExtend ? "main-content" : ""}`}>
                    {showStockMessage ? (
                      <div className="button-carts notify-it">
                        <NotifyItems
                          item={item}
                          fromCart={true}
                          isListExtend={isListExtend}
                          showStockMessage={showStockMessage}
                        />
                      </div>
                    ) : (
                      <>
                        <PriceLabel priceInfo={item} itemStock={itemStock} />
                        <div className="color-content">
                          <div
                            className={`color-content-inner ${
                              checWithswatchfullWidth && !itemDiscontinue
                                ? "d-flex"
                                : ""
                            }`}
                          >
                            <div
                              className={`color-content-text  ${fullscreenClass}  `}
                            >
                              <p className="fs-16 fw-300 text-color">
                                <span className="fw-400 mr-5">
                                  {colorFinish}
                                </span>
                                {item?.currentVarent?.label || "N/A"}
                              </p>
                              {variantList.length > 1 ? (
                                <SwatchItems
                                  variantList={variantList}
                                  setVariant={setVariant}
                                  variant={variant}
                                  isListExtend={cartFlagFullWidth}
                                />
                              ) : null}
                            </div>
                            <div
                              className={`d-flex justify-content-center flex-column ${fullscreenClass} ${
                                checWithswatchfullWidth ? "carts-fullwidth" : ""
                              }`}
                            >
                              {inventoryWarn ? (
                                <div className="inventory-warning-section">
                                  <WarnIcon /> {inventoryTextVal(inventory)}
                                </div>
                              ) : null}

                              <div
                                className={`button-carts d-flex flex-row justify-content-center align-items-end mt-3`}
                              >
                                <div
                                  className={`d-flex flex-column processing-div ${
                                    loaded ? "processing" : ""
                                  }`}
                                >
                                  {!item?.currentVarent?.details
                                    ?.discontinued &&
                                  loading === "success" &&
                                  inventory ? (
                                    <div className="addtocart-widgets d-flex">
                                      <div className="counter-widgets d-flex">
                                        <button
                                          className="decrement-widgets"
                                          onClick={decrementCounter}
                                        >
                                          <DecIcon />
                                        </button>
                                        <input
                                          type="number"
                                          onChange={e =>
                                            handlerCounter(e?.target?.value)
                                          }
                                          value={counter}
                                        />
                                        <button
                                          className="increment-widgets"
                                          onClick={incrementCounter}
                                        >
                                          <IncIcon />
                                        </button>
                                      </div>

                                      <Button
                                        label={getButtonLabel(loaded)}
                                        onClick={buttonHandler}
                                        disabled={loaded}
                                        tag="button"
                                        className={`fs-18 fw-500 add-to-cart d-flex align-items-center justify-content-center ${
                                          isAdding !== "" ? "disabled" : ""
                                        }`}
                                        parentClass={`button-carts`}
                                      />
                                    </div>
                                  ) : null}

                                  {itemStock ? (
                                    <NotifyItems
                                      showStockMessage={showStockMessage}
                                      item={item}
                                      fromCart={true}
                                      isListExtend={isListExtend}
                                      itemStock={itemStock}
                                    />
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Container>
          )}
        </div>
      </div>
    </div>
  )
}

AddCart.propTypes = {
  productId: PropTypes.string.isRequired,
  setShowCart: PropTypes.func.isRequired,
  showCart: PropTypes.bool.isRequired,
  setCartToast: PropTypes.func.isRequired,
  analytics: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isListExtend: PropTypes.bool.isRequired,
  partController: PropTypes.shape({
    actions: PropTypes.shape({
      get: PropTypes.shape({
        entryByKey: PropTypes.func.isRequired,
      }),
    }),
  }),
}

export default AddCart
